














































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IIDNamePairWithColor } from '@/types/data-objects/global'
import { availableSizeOptions } from '@/types/button-style-options'

/* API */

export default Vue.extend({
  name: 'SelectButton',
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },

    options: {
      type: Array as () => IIDNamePairWithColor[],
      default: (): IIDNamePairWithColor[] => [],
    },

    title: {
      type: String,
      default: '',
    },

    size: {
      type: String,
      default: 'large',
      validator: (value: string) => {
        return availableSizeOptions.includes(value)
      },
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      internalValue: 0,
    }
  },

  computed: {
    selectedItem(): IIDNamePairWithColor {
      if (!this.internalValue) {
        return this.options[0]
      }
      return this.options.find(o => o.id === this.internalValue)
    },
    selectedColor(): string {
      return this.getColor(this.selectedItem)
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.internalValue = newVal
      },
    },
  },

  methods: {
    getColor(value: IIDNamePairWithColor) {
      return value ? value.color : 'grey'
    },

    handleSelect(value: number) {
      this.internalValue = value
      this.$emit('input', value)
      // @ts-ignore
      this.$refs.selectButtonDropdown.handleClose()
    },
    isSelected(item: any) {
      if (this.selectedItem) {
        return item.id === this.selectedItem.id
      }
      return false
    },
  },
})
